import { Component, OnInit } from '@angular/core';
import * as jQuery from 'jquery';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss']
})
export class GroupComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {
  }
}
